export default __webpack_public_path__ + "static/media/TopL_Red.ed068304.png";